<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { projectService } from "../../../services/projectservice/project.service";
import { servicehelpers } from "../../../services/servicehelpers";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "bookings List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      bookingData: {},
      typeData: {},
      groupData: {},
      floorData: {},
      projectData: {},
      fetchingStats: false,
      title: "bookings List",

    };
  },
  mounted() {
    this.loadingData();
    this.loadingprojectData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      bookingService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.bookingData = response;
        });
    },

    deleted: function(id) {
      bookingService.remove(id)
        .then(response => {
        
          // this.bookingData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-add",
          });
    },

    projectChanged: function(event) {
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

        });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

  }
            // v-bind:deletes="[deleted, null]"
};
</script>

<template>
  <Layout style="background: 'red'">
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'booking-add'}"
    :title="$t('menuitems.booking.text')" />
    <List v-bind:dataList="bookingData" 
          v-bind:edit="{link: 'booking-edit'}"
          
          v-bind:more="{
            sub: [{
            //  name: 'property.contract', link: 'property-contract', column: 'id'
            //}, {
               name: 'property.sell', icon:'bx bx-cart', link: 'sale/add', query: 'bookingid', column: 'id' //, show: {column: 'property_status_id', value: 1}
            }, {
              name: 'booking.delay', icon:'bx bx-time-five', link: 'property-book-delay', column: 'id'
            }, {
              name: 'booking.extend', icon:'bx bx-fullscreen', link: 'booking-extend', column: 'id'
            }, {
              name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property/cancelation', query: 'bookingid', column: 'id'
            }, {
              name: 'booking.transfer-property.text', icon: 'bx bx-sync', link: 'booking-transfer', column: 'id'
            }, {
              name: 'payment.receipt', icon:'bx bx-receipt', link: 'booking-receipt', column: 'id'
            }]

          }"
          v-bind:filter="{
            search: ['bookings.code', 'customers.name', 'customers.name_en', 'properties.code'],
            dropdown: [{
              title: 'property.project',
              field: 'properties.project_id',
              data: this.projectData.data,
              method: (event) => projectChanged(event),
              default: 1,
              width: 2
            }, {
              title: 'property.group',
              field: 'properties.property_group_id',
              data: this.groupData.data,
            }, {
              title: 'property.floor',
              field: 'properties.project_floor_id',
              show: 'number',
              data: this.floorData.data,
            }],
            date: {
              title: 'general.date',
              field: 'bookings.booking_date'
            }
          }"

          v-bind:module="'booking'"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'currency_en'}, {name: 'booking_date', type: 'date'}, {name: 'expire_date', type: 'date'}, 
                    {name: 'price', type: 'currency'}, {name: 'discount', type: 'currency'},  
                    {name: 'booking_amount', type: 'currency'}, {name: 'sale_price', type: 'currency'}]"
          v-bind:fields="[ `code: ${$t('booking.code')}`, `customer: ${$t('customer.text')}`, 
            `property: ${$t('property.text')}`, `booking_date: ${$t('general.date')}`, `currency_en: ${$t('property.currency')}`, 
            `price: ${$t('booking.price')}`, // Price
            `discount: ${$t('booking.discount')}`, // Discount
            `sale_price: ${$t('booking.sale-price')}`, // Sale Price
            `booking_amount: ${$t('booking.deposit')}`,  // Deposit
            `expire_date: ${$t('booking.expired')}`]" />
  </Layout>
</template>